import Vue from 'vue';

// Domain
import { RiskToleranceQuestionsStateManager } from '../../domain/state/risk-tolerance-questions-state-manager';
import RiskToleranceQuestionsState from '../../domain/state/risk-tolerance-questions-state';
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';

@Injectable()
export default class RiskToleranceQuestionsVueStateManager implements
  RiskToleranceQuestionsStateManager {
  // eslint-disable-next-line max-len
  private _state: RiskToleranceQuestionsState = Vue.observable<RiskToleranceQuestionsState>(new RiskToleranceQuestionsState());

  private readonly observers: Observer[] = [];

  get state(): RiskToleranceQuestionsState {
    return this._state;
  }

  set state(value: RiskToleranceQuestionsState) {
    this._state = value;
    this.notifyAll();
  }

  patch(state: Partial<RiskToleranceQuestionsState>) {
    type Keys = keyof RiskToleranceQuestionsState;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.state[accessor] = value;
      }
    });
  }

  notifyAll() {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer) {
    this.observers.push(observer);
  }
}
